import { useIntl } from 'react-intl'
import { fonts } from 'app-v2/design-systems'
import React, { type ReactNode } from 'react'
import styled from 'styled-components'
import { media } from '../../../../assets/styles'
import { BORDER, SPACING } from '../../../../../app-v2/design-tokens'
import { colors } from '../../../../../app-v2/design-systems'
import { TPKColors } from '../../../colors'
import { Text } from 'app/common/typography'

export const Item = ({ children }: { children: ReactNode }) => {
    const intl = useIntl()
    return (
        <StyledExplanations>
            <StyledExplanation>
                <StyledPoint></StyledPoint>
                <StyledExplainationTextContainer>
                    <Text font={fonts.flameSansRegular}>
                        {intl.formatMessage({
                            id: 'tupreferesking.home.explanation.text.1'
                        })}
                    </Text>
                </StyledExplainationTextContainer>
            </StyledExplanation>
            {children}
            <StyledExplanation>
                <StyledPoint></StyledPoint>
                <StyledExplainationTextContainer>
                    <Text font={fonts.flameSansRegular}>
                        {intl.formatMessage({
                            id: 'tupreferesking.home.explanation.text.4'
                        })}
                    </Text>
                </StyledExplainationTextContainer>
            </StyledExplanation>
            <StyledExplanation end>
                <StyledPoint></StyledPoint>
                <StyledExplainationTextContainer>
                    <Text font={fonts.flameSansRegular}>
                        {intl.formatMessage({
                            id: 'tupreferesking.home.explanation.text.5'
                        })}
                    </Text>
                </StyledExplainationTextContainer>
            </StyledExplanation>
        </StyledExplanations>
    )
}

const StyledMainContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: ${SPACING.M};
`
const StyledCard = styled.div`
    background-color: ${colors.white};
    border-radius: ${BORDER.RADIUS.XL};
    padding: ${SPACING.XL};
    ${media.medium`padding: 48px;`}
    display: flex;
    flex-direction: column;
    gap: ${SPACING.S};
    ${media.medium`gap: ${SPACING.L};`}
    position: relative;
    max-width: 850px;
    align-self: center;
`

const StyledTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SPACING.XS};
    ${media.medium`align-items: center;`}
`

const StyledBuoyContainer = styled.div`
    display: flex;
    position: absolute;
    flex: 1;
    z-index: 1;
    right: 0;
    top: 0;
    img {
        position: absolute;
        right: -${SPACING.M};
        top: -${SPACING.XL};
        height: 84px;
    }
`
const StyledExplanationItem = styled.div`
    display: flex;
    border-bottom: 1px solid ${colors.bbq30};
    flex-direction: column;
`

const StyledItemTitle = styled.a`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${SPACING.M} ${SPACING.XXS} ${SPACING.M} 0;
    ${media.medium`
        justify-content: start;
        gap: ${SPACING.XXS};`}
`

const StyledItemDescription = styled.div`
    overflow: hidden;
    max-height: 0;
    padding: 0 ${SPACING.S};
    transition: max-height 0.2s, padding 0.2s;
    ${props =>
        props.opened &&
        `
        max-height: none; 
        padding: ${SPACING.XS} ${SPACING.S} 0;`}
`

const StyledTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${SPACING.XS};
    align-items: center;
`

const StyledExplanations = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
`

const StyledExplanation = styled.div`
    border-left: 1px solid
        ${props => (props.end ? colors.white : TPKColors.explanationBlue)};
    display: flex;
    flex-direction: row;
    padding-left: ${SPACING.S};
    padding-bottom: ${SPACING.L};
`

const StyledPoint = styled.div`
    background-color: ${TPKColors.explanationBlue};
    border-radius: 50%;
    height: ${SPACING.XXS};
    width: ${SPACING.XXS};
    position: absolute;
    left: -${SPACING.XXXS};
`

const StyledExplainationTextContainer = styled.div`
    margin-top: -${SPACING.XXXS};
`
